<template>
  <main class="support-page">
    <section class="section support-page">
      <div class="wrapper">
        <template v-if="faqData && faqData.length > 0">
          <div class="faq-category-section">
            <FaqSection :faq="faqData" />
          </div>
        </template>
        <div v-else-if="!isFetchingData && !faqData" class="no-faq-message">
          {{ $t("No FAQs found.") }}
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import FaqSection from "@/components/FaqSection.vue";
export default {
  props: {
    lang: {
      type: String,
      required: true,
    },
  },
  components: {
    FaqSection,
  },
  data() {
    return {
      faqData: null,
      isFetchingData: true,
    };
  },
  computed: {
    ...mapGetters("app", ["currentLanguage"]),
  },
  watch: {
    currentLanguage() {
      this.fetchFaqData();
    },
    lang() {
      this.fetchFaqData();
    },
  },
  mounted() {
    this.fetchFaqData();
  },
  methods: {
    fetchFaqData() {
      this.isFetchingData = true;
      this.$http
        .get(`${process.env.VUE_APP_API}faq`, {
          params: {
            // include_categories: true,
            lang_id: this.currentLanguage,
          },
        })
        .then((response) => {
          if (response && response.data) {
            this.faqData = response.data.payload;
          } else {
            console.error("Invalid response data:", response);
          }
        })
        .catch((error) => {
          console.error("Error fetching FAQ data:", error);
        })
        .finally(() => {
          this.isFetchingData = false;
        });
    },
  },
};
</script>

<style scoped>
.section .wrapper {
  padding: 40px 0;
}
.no-faq-message {
  font-size: 48px;
  font-weight: 400;
  text-align: center;
  color: #ffffff;
}
</style>
